import SmoothScrollIntoView from '../__utils/smoothScrollIntoView';
import Forms from '../__utils/forms';
import viewportUnits from '../__utils/viewportUnits';
import { sectionsInView, resetObservers } from '../__utils/sectionsInView';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		document.querySelector('html').classList.remove('no-js');
		SmoothScrollIntoView();
		viewportUnits();
	},
	loaded() {
		// Only add functions here that are okay to run after the entire page has loaded (include media/images).
		Forms();
		viewportUnits();
		sectionsInView();
	},
	resized() {
		viewportUnits();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
